import {
  Badge,
  CopyToClipboard,
  Dropdown,
  FlexBox,
  Table,
  Tooltip,
} from '@dixa/lib-shared-habla';
import { useRef, useState } from 'react';
import { useClickAway } from 'react-use';

import styles from '../../../styles/recipient-pill.module.scss';

type EmailRecipient = {
  name?: string | null;
  email: string;
};

type RecipientPillProps = {
  from?: EmailRecipient;
  toList: Array<EmailRecipient>;
  ccList: Array<EmailRecipient>;
  bccList: Array<EmailRecipient>;
};

const RecipientPill = ({
  from,
  toList,
  ccList,
  bccList,
}: RecipientPillProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  useClickAway(rootRef, () => {
    setIsOpen(false);
  });

  const titleParts: string[] = [];
  if (toList.length > 0) titleParts.push('To');
  if (ccList.length > 0) titleParts.push('Cc');
  if (bccList.length > 0) titleParts.push('Bcc');
  const title = titleParts.join('/');

  const emailRecipients = [
    { label: 'From', list: from ? [from] : [] },
    { label: 'To', list: toList },
    { label: 'Cc', list: ccList },
    { label: 'Bcc', list: bccList },
  ];

  return (
    <div ref={rootRef} className={styles.recipientPill}>
      <Badge
        className={styles.badge}
        variant="primary"
        size="small"
        onClick={() => setIsOpen(!isOpen)}
      >
        {title}
      </Badge>

      <Dropdown
        fixed
        isOpen={isOpen}
        style={{ maxWidth: 400, maxHeight: 300, overflow: 'auto' }}
      >
        <Table
          className={styles.table}
          wrapperProps={{
            className: styles.tableWrapper,
          }}
        >
          <Table.Tbody>
            {emailRecipients.map(({ label, list }, i) => {
              return (
                list.length > 0 && (
                  <Table.Tr key={`${label}-${i}`}>
                    <Table.Td>{label}</Table.Td>

                    <Table.Td>
                      <FlexBox gap="100" flexWrap="wrap">
                        {list.map((emailRecipient, i) => (
                          <Tooltip
                            key={`${emailRecipient.email}-${i}`}
                            content="Click to copy the email address"
                          >
                            <CopyToClipboard
                              tooltip
                              textToCopy={emailRecipient.email}
                            >
                              <Badge
                                variant="secondary"
                                size="medium"
                                className={styles.badge}
                              >
                                {emailRecipient.name
                                  ? `${emailRecipient.name} <${emailRecipient.email}>`
                                  : emailRecipient.email}
                              </Badge>
                            </CopyToClipboard>
                          </Tooltip>
                        ))}
                      </FlexBox>
                    </Table.Td>
                  </Table.Tr>
                )
              );
            })}
          </Table.Tbody>
        </Table>
      </Dropdown>
    </div>
  );
};

export default RecipientPill;
